import React from 'react';
import {Row, Col} from 'react-flexbox-grid';
import {
    withStyles,
    Typography,
} from '@material-ui/core';
import {withRouter} from 'react-router-dom';
import PropTypes from 'prop-types';

const styles = () => ({
    root : {
        marginTop    : 70,
        display : 'flex',
        textAlign : 'center',
        justifyContent : 'center',
        width : "100%",
    },
    contentText : {
        textAlign : 'center',
        padding : 12
    },
    contentImg : {
        minHeight: 130,
        textAlign : "center",
        width : "100%",
        height : 130,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
    },
    title : {
        fontSize : 14,
        fontWeight : 'bold',
        minHeight : 50,
        fontFamily : "'Poppins', sans-serif"
    },
    text : {
        fontSize : 13,
        fontFamily : "'Poppins', sans-serif"
    },
    buttonClass: {
        '&:hover': {
            cursor: "pointer",
            border      : "solid",
            borderWidth : 1,
            borderColor : "#b2dfdb",
            borderRadius : 10,
            boxShadow: "2px 4px 2px #b2dfdb",
            elevation : 6

        },
        margin      : 10,
        padding     : 10,
        maxWidth    : 300,
        border      : "solid",
        borderWidth : 1,
        borderColor : "#e0f2f1",
        borderRadius : 10,
        boxShadow: "2px 4px 2px #e0f2f1",
        elevation : 5
    },
    button : {
        marginTop : 48,
    }
});

/**
 * Componente para la renderización de los botones en la landing page
 * Jhoan López <jhoanlt19@gmail.com>
 * @param {*} param0 
 */
const IndicatorTypesFilters = ({classes, data=[], history}) => {

    function redirect(item) {
        localStorage.setItem("indicatorType", JSON.stringify(item));
        history.push({ pathname: '/home', params: { indicatorType: item } })
    }

    return(
        <Row className={classes.root}>
                {data && data.allIndicatorTypes && data.allIndicatorTypes.map((item, key) => (
                    <Col xs={12}
                        className={classes.buttonClass}
                        onClick={() => redirect(item)}
                        key={key}
                    >
                        <div className={classes.contentImg}>
                            <img
                                src={item.image ? item.image : "https://vgde-files.s3.amazonaws.com/empty.png"}
                                alt="indicador"
                                width={item.name === "Salud en el territorio" ? 140 : 190}
                            />
                        </div>
                        <div className={classes.contentText}>
                            <Typography
                                align="center" 
                                gutterBottom 
                                className={classes.title}
                                display="block"
                            >
                                {item.name}
                            </Typography>
                            <Typography 
                                variant="inherit" 
                                align="justify" 
                                gutterBottom 
                                className={classes.text}
                                display="block"
                            >
                                {item.description}
                            </Typography>
                        </div>
                    </Col>
                ))}
        </Row>
    )
};

IndicatorTypesFilters.propTypes = {
    classes : PropTypes.object,
    data    : PropTypes.object,
    history : PropTypes.object,
}

export default withRouter(withStyles(styles)(IndicatorTypesFilters));


// WEBPACK FOOTER //
// ./src/components/landing-page/indicatorTypeFilters.js